export default __webpack_public_path__ + "static/media/icono-rendimiento.d019e417.png";